module.exports = __webpack_public_path__ + "static/connie-d800be31f5285c32745f5b0765da0123.jpg";